import React from "react";
import { useTranslation } from 'react-i18next';
import ErrorBoundary from "./ErrorBoundary";

const ErrorBoundaryWithTranslation = ({ children }) => {
  const { t } = useTranslation();

  return <ErrorBoundary t={t}>{children}</ErrorBoundary>;
};

export default ErrorBoundaryWithTranslation;
